import 'core-js/features/object';
import 'core-js/features/number';
import 'core-js/features/array';

function elementMatchesPolyfill() {
	if (!Element.prototype.matches) {
		Element.prototype.matches =
			Element.prototype.msMatchesSelector ||
			Element.prototype.webkitMatchesSelector;
	}
}

function elementClosestPolyfill() {
	if (!Element.prototype.closest) {
		Element.prototype.closest = function(s) {
			var el = this;

			do {
				if (el.matches(s)) return el;
				el = el.parentElement || el.parentNode;
			} while (el !== null && el.nodeType === 1);
			return null;
		};
	}
}

elementClosestPolyfill();
elementMatchesPolyfill();
